angular.module('jv.Jobseeker', [
    'jv.services',
    'ngRoute',
    'jv.Common.TemplateLoader',
    'jv.Privacy.Policy.Directive',
    'jv.Common.Modal',
    'jv.Common.Filters',
    'App'
], ['$routeProvider', function ($routeProvider) {
    /*** Routing ***/
    var listTmpl = {
        templateUrl: window.jvUrls.jobSeeker + '/jobseeker/list.html',
        controller: 'AppList'
    };
    var detailsTmpl = {
        templateUrl: window.jvUrls.jobSeeker + '/jobseeker/details.html',
        controller: 'AppDetails'
    };
    $routeProvider.when('/details/:jobId', detailsTmpl);
    $routeProvider.when('/list', listTmpl);
    $routeProvider.otherwise({
        redirectTo: '/list'
    });
}]).config(['$locationProvider', function($locationProvider) {
    $locationProvider.hashPrefix('');
}]);